import React, { useEffect, useState } from 'react'
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import { Link } from "react-router-dom";
import axios from 'axios';
import { API_URL, APP_URL } from '../../Config';

const Latestnew = () => {
    const [news, Setnews] = useState("");
    const fetchnews = async () => {

        return await axios.get(`${API_URL}/indexData.php?type=fetchnews`, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(res => {
            Setnews(res.data);
        })
    }

    useEffect(() => {
        fetchnews();
    }, [])

    return (
        
            <Box className="" marginY='30px' marginBottom='30px'>
                <Container maxWidth='xl'>
                    <Typography variant='h2' fontSize='45px' fontWeight='bold' paddingBottom='20px'> Latest News </Typography>
                    <Grid container spacing={1}>
                        {news.length > 0 && news.map((news, index) => (
                            <Grid key={index} item lg={4} sm={4} md={4} xs={12} marginBottom='30px'>
                                <Box className='Collector_point'>
                                <Link to={`/New_details/${news.id}`}>   <img src={APP_URL + '/' + news.image} width='100%' /></Link>
                                    <Box className='Digital'>
                                        <Link to={`/New_details/${news.id}`}>
                                            <Box>
                                                <Typography fontWeight='400' fontSize='16px' variant='h6' color='#000'>
                                                    {news.time}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography fontWeight='600' fontSize='22px' variant='h6' color='#000'>
                                                    {news.title}
                                                </Typography>
                                            </Box> 
                                        </Link>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        
    )
}

export default Latestnew;  